import { render, staticRenderFns } from "./TicketPaperPreview.vue?vue&type=template&id=349c4e29"
import script from "./TicketPaperPreview.vue?vue&type=script&lang=js"
export * from "./TicketPaperPreview.vue?vue&type=script&lang=js"
import style0 from "./TicketPaperPreview.vue?vue&type=style&index=0&id=349c4e29&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349c4e29')) {
      api.createRecord('349c4e29', component.options)
    } else {
      api.reload('349c4e29', component.options)
    }
    module.hot.accept("./TicketPaperPreview.vue?vue&type=template&id=349c4e29", function () {
      api.rerender('349c4e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/bookingAndTickets/TicketPaperPreview.vue"
export default component.exports